import { getRegionalApiHost } from "../regionalApi";
import { AccountRegion } from "../types/regionalApi";
import { Analytics, IdentifyOptions } from "./types";

export interface IdentifySendGridUserOptions {
  makoAuthToken?: string;
  accountRegion: AccountRegion;
  identity: IdentifyOptions;
}

/**
 * Points analytics at the account's regional API host with its Mako token, then identifies the
 * user. Every path that lands a user in a SendGrid session runs this pair, in this order.
 */
export const identifySendGridUser = async (
  analytics: Analytics,
  { makoAuthToken, accountRegion, identity }: IdentifySendGridUserOptions
): Promise<void> => {
  analytics.load({ makoAuthToken, apiHost: getRegionalApiHost(accountRegion) });
  await analytics.identify(identity);
};
